import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

// Service Class
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { CppReturnsService } from '../../../services/cpp-returns/cpp-returns.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';

// Class
import { DashboardFilter } from '../../../models/DashboardFilter';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-cpp-returns-review',
  templateUrl: './cpp-returns-review.component.html',
  styleUrls: ['./cpp-returns-review.component.scss']
})
export class CppReturnsReviewComponent implements OnInit, AfterViewInit, OnDestroy {
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  // Header selected values
  shipToAccount: number;
  deliveryAccount: number;
  deliveryAccountName: string;
  shipToAccountName: number;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  originalProductItemsDataSource: any;
  productAllDataSource: any;
  displayedColumns: string[] = ['checkbox', 'product', 'itemNumber', 'units', 'dumpedUnits', 'uom', 'packageSize', 'notes'];
  isParent = false;
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  index: any;
  returnRequestNumber = 0;
  returnRequestId = 0;
  accountEmail: string;
  readOnlyAccess = false;
  userMenuAccessList: any;
  dsmInfo: string;
  productList: any[];
  userIdRole: string;
  isApprovalAccess = false;
  createRequestAccess = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate = true;
  requestStatus: string;
  isPickupDateValid = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;
  breadcrumbtext: string;
  onBehalfUser: any;
  onBehalfUserName: string;
  selectedUserName: string;
  isRequestPending = true;;
  isShowNonSubEmail: boolean = true;
  isReturnTypeForInnoculant: boolean = false
  warningMessage: string = "";
  dsmId: number = 0;
  public isApprovalRequired: boolean = false;

  public desiredPickupDate: any;
  public contactName: string;
  public contactNumber: string;
  public customerPONumber = 'Return';
  public shippingInstructions: string;
  public selectedFreightInstruction: string;
  public selectedFreightInstructionName: string;
  public palletCount: number;
  soldToAccount: number;
  shipToAddress: string;
  soldToaccountName: string;
  soldToaddress: string;
  shipToAcnumber: string;
  soldToAcnumber: string;

  private subscription = new Subscription();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    public cppReturnsService: CppReturnsService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private localStorageService: LocalStorageService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    this.requestStatus = this.cppReturnsService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS);

          this.isReturnTypeForInnoculant = this.cppReturnsService.isReturnTypeForInnoculant
          if (this.isReturnTypeForInnoculant) {
            this.cppReturnsService.getCPPReturnsInoculantWarningMessage().subscribe((result: any) => {
              this.warningMessage = result.message
            });
          }

          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          // Get Return Request Id from URL
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x['returnRequestId']) {
              this.returnRequestId = +x['returnRequestId'];
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }));
        }
        this.enableCreate = true;
      }
    }

    this.productAllDataSource = new MatTableDataSource([]);
    this.cppReturnsService.setEditModeStatus(false);
    this.errorMsgs = new Array();
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  checkApprovalRequired() {
    if (this.isReturnTypeForInnoculant) {
      let isShowApproveButton = this.productAllDataSource.data.filter(x => x.isIPConfigured && x.returnQuantity > x.eligibleUnit)

      if (isShowApproveButton.length > 0) {
        this.isApprovalRequired = true
      }
      else {
        this.isApprovalRequired = false
      }
    }
    else {
      this.isApprovalRequired = false
    }
  }

  //Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppReturnsService.getEditRequestDetail(this.returnRequestId).subscribe((result: any) => {
      this.breadcrumbtext = 'Review Return Request [' + result.returnRequestNumber + ']';
      this.cppReturnsService.setEditModeStatus(true);
      this.isPickupDateValid = true;
      this.isNameValid = true;
      this.isContactValid = true;
      this.isPalletValid = true;
      this.cppReturnsService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      this.enableCreate = false;
      this.editApprovalList = result;
      if (result.cppReturnsProductList && result.cppReturnsProductList.length > 0) {
        result.cppReturnsProductList.forEach(x => {
          x.isSelected = false;
          x.eligibleUnit = x.isManualLine ? 0 : x.eligibleUnit;
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
          if (!this.isApprovalAccess && x.lineStatus == 'PENDING') {
            x.isIncreaseQtyDisable = true;
            x.isDecreaseQtyDisable = true;
          }
          else if (!this.isApprovalAccess && x.lineStatus == 'APPROVED') {
            x.isIncreaseQtyDisable = true;
          }
          if (this.isReturnTypeForInnoculant) {
            if (x.isIPConfigured && x.returnQuantity > x.eligibleUnit) { x.isShowInoculantWarning = true }
            else { x.isShowInoculantWarning = false }
          }
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      this.cppReturnsService.setSelectedAccountNo(this.shipToAccount);
      this.dsmInfo = result.dsmName;
      this.isParent = result.isParent;
      this.cppReturnsService.setProductList(result.cppReturnsProductList);
      this.originalProductItemsDataSource = [];
      this.bindDataSource(result.cppReturnsProductList, true);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.cppReturnsProductList));
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;
      this.getUserList(this.shipToAccount);

      this.cppReturnsService.setSelectedAccountNo(result.shipToAccountId);
      const approvedItem = result.cppReturnsProductList.filter(x => x.lineStatus == 'APPROVED');
      if (approvedItem.length > 0) {
        this.isRequestPending = false;
      }
      this.checkApprovalRequired()
      this.dsmId = result.dsmId;
      this.contactName = result.pickupInfo.contactName;
      this.contactNumber = result.pickupInfo.contactNumber;
      this.customerPONumber = result.pickupInfo.custPONumber;
      this.palletCount = result.pickupInfo.palletCount;
      this.desiredPickupDate = new Date(result.pickupInfo.requestDate);
      this.deliveryAccount = result.pickupInfo.pickUpLocation;
      this.deliveryAccountName = result.pickupInfo.pickUpLocationName;
      this.shippingInstructions = result.pickupInfo.shippingInstructions;
      this.selectedFreightInstruction = result.pickupInfo.freightInstructions;
      this.selectedFreightInstructionName = result.pickupInfo.freightInstructionsDescription;
      this.shipToAddress = result.shipToAccount.address1;
      this.soldToaccountName = result.soldToAccount.accountName;
      this.soldToaddress = result.soldToAccount.address1;
      this.soldToAcnumber = result.soldToAccount.accountNumber;
      this.shipToAcnumber = result.shipToAccount.accountNumber;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getUserList(accountNumber) {
    const self = this;
    this.subscription.add(this.cppReturnsService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        result.filter(x => {
          const accountNameArr = x.userName.split(',');
          if (accountNameArr.length > 1) {
            x.userName = accountNameArr[1] + ' ' + accountNameArr[0];
          }
        });
        this.requestOnBehalfList = result;
        // if (this.currentRequestedUser) {
        //  let requestItem = this.requestOnBehalfList.filter(r => r.userId == this.currentRequestedUser);
        //  this.requestedByUser = requestItem[0].userId;
        // }
        if (this.onBehalfUser) {
          const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.onBehalfUser);
          if (requestItem) {
            this.onBehalfUserName = requestItem[0].userName;
            this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
            this.requestedByUser = requestItem[0].userId;
          }
        }

        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  backToRequest() {
    this.router.navigate(['/cpp-returns/request-products', this.returnRequestId]);
  }

  // On page destroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  submitForApproval(isSubmit: boolean) {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    var newLineItems = [];
    this.productAllDataSource.data.filter(x => {
      newLineItems.push(JSON.parse(JSON.stringify(x)));
      x.lineStatus = 'PENDING'
      x.errorMessage = null;
    });
    var productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    var postData = {
      ReturnRequestCppId: this.returnRequestId,
      ReturnRequestType: this.isReturnTypeForInnoculant ? 'INOCULANT' : 'PRODUCTS',
      ReturnRequestStatus: 'PENDING',
      CompanyCode: this.headerCompany,
      ShipToAccountId: this.shipToAccount,
      IsUpdateRequest: this.cppReturnsService.getEditModeStatus(),
      DsmId: this.dsmId,
      BranchPlant: null,
      CPPReturnProductList: productList,
      Email: this.accountEmail,
      RequestedBy: this.requestedByUser,
      PickupInfo: {
        RequestDate: (this.desiredPickupDate ? (new Date(this.desiredPickupDate)).toLocaleDateString('en-US').replace(/\u200E/g, '') : null),
        ContactName: (this.contactName ? this.contactName : ""),
        ContactNumber: (this.contactNumber ? this.contactNumber : ""),
        PickUpLocation: (this.deliveryAccount ? this.deliveryAccount : null),
        ShippingInstructions: (this.shippingInstructions ? this.shippingInstructions : null),
        FreightInstructions: this.selectedFreightInstruction,
        PalletCount: (this.palletCount ? Number(this.palletCount) : null),
        CustPONumber: (this.customerPONumber ? this.customerPONumber : "")
      },
    }
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.cppReturnsService.submitReturnRequest(postData).subscribe((result: any) => {
      if (result) {
        if (result.errors.length > 0) {
          this.loaderService.setLoaderStatus(false);
          result.errors.forEach(x => {
            this.toastrService.error(x);
            return false;
          });
        }
        else {
          let errorCount = result.cppReturnProductList.filter(x => x.errorMessage != null).length;
          if (errorCount > 0) {
            this.productAllDataSource.data = result.cppReturnProductList;
            this.productAllDataSource.data.forEach(x => {
              let item = newLineItems.filter(y => y.itemId == x.itemId);
              if (item.length > 0) {
                x.lineStatus = item[0].lineStatus;
              }
              if (x.errorMessage != '' && x.errorMessage != null) {
                x.lineErrors = { "itemId": x.itemId, "errors": [{ "error": x.errorMessage }] };
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { "itemId": x.itemId, "errors": [] };
              }
            });
            this.getCommonErrors(this.errorMsgs);
            this.loaderService.setLoaderStatus(false);
          } else {
            let successMsg = "Inoculant return request sent for approval."
            this.toastrService.success(successMsg);
            if (this.isReturnTypeForInnoculant) {
              this.router.navigate([`/cpp-returns/dashboard-products/Inoculant`]);
            }

            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.loaderService.setLoaderStatus(false);
          }
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error("Inoculant return Request not saved in the system.");
    }));
  }

  submitJDERequest() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    this.editApprovalList.isUpdateRequest = true;
    const productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    const newLineItems = [];
    productList.filter(x => {
      if (x.lineStatus === '' || x.lineStatus === null) {
        newLineItems.push(JSON.parse(JSON.stringify(x)));
      }
      if (x.lineStatus === '' || x.lineStatus === null) {
        x.lineStatus = 'PENDING';
      }
      x.errorMessage = null;
    });
    const item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
    if (this.requestedByUser && item) {
      this.selectedUserName = item.userName;
    }

    this.editApprovalList.cppReturnProductList = productList;
    // this.editApprovalList.scaleTicketList = this.scaleTicketList;
    this.editApprovalList.email = this.accountEmail;
    this.editApprovalList.emailUserName = this.selectedUserName;
    this.editApprovalList.requestedBy = this.requestedByUser;
    this.editApprovalList.PickupInfo = {
      RequestDate: this.desiredPickupDate,
      ContactName: this.contactName,
      ContactNumber: this.contactNumber,
      PickUpLocation: this.deliveryAccount,
      ShippingInstructions: this.shippingInstructions,
      FreightInstructions: this.selectedFreightInstruction,
      PalletCount: Number(this.palletCount)
    };

    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppReturnsService.submitToJDEReturnRequest(this.editApprovalList).subscribe((result: any) => {
      if (result) {
        const errorCount = result.cppReturnProductList.filter(x => x.errorMessage != null).length;
        if (errorCount > 0) {
          this.productAllDataSource.data = result.cppReturnProductList;
          this.productAllDataSource.data.forEach(x => {
            const item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
            if (item.length > 0) {
              x.lineStatus = item[0].lineStatus;
            }
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).lineError = x.lineError;
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            // this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            if (x.errorMessage != '' && x.errorMessage != null) {
              x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [{ 'error': x.errorMessage }] };
              x.lineError = true;
              this.errorMsgs.push(x.lineErrors);
            }
            else {
              x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
              x.lineError = true;
            }
          });
          this.getCommonErrors(this.errorMsgs);
          this.loaderService.setLoaderStatus(false);
        } else {
          let successMsg = 'Return Request submitted successfully.';
          this.toastrService.success(successMsg);
          this.router.navigate([`/cpp-returns/products-confirmation/${this.returnRequestId}`]);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.loaderService.setLoaderStatus(false);
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Return Request not saved in the system.');
    }));
    // }
  }

  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }
}
